import { render, staticRenderFns } from "./editMiniAppAdv.vue?vue&type=template&id=5386ed73&scoped=true&"
import script from "./editMiniAppAdv.vue?vue&type=script&lang=js&"
export * from "./editMiniAppAdv.vue?vue&type=script&lang=js&"
import style0 from "./editMiniAppAdv.vue?vue&type=style&index=0&id=5386ed73&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5386ed73",
  null
  
)

export default component.exports